import React from "react";
import { StyleSheet } from "react-native";
import Animated, { Easing, ReduceMotion, useAnimatedStyle, withTiming, } from "react-native-reanimated";
export const CollapsibleView = ({ isVisible, maxHeight = 64, children, style, pointerEvents = "auto", ...props }) => {
    const animatedStyle = useAnimatedStyle(() => {
        const timing = {
            duration: 200,
            easing: Easing.out(Easing.ease),
            reduceMotion: ReduceMotion.System,
        };
        return {
            maxHeight: withTiming(isVisible ? maxHeight : 0, timing),
            opacity: withTiming(isVisible ? 1 : 0, timing),
        };
    });
    return (<Animated.View {...props} aria-hidden={!isVisible} accessibilityElementsHidden={!isVisible} importantForAccessibility={isVisible ? "auto" : "no-hide-descendants"} pointerEvents={isVisible ? pointerEvents : "none"} style={[styles.container, animatedStyle, style]}>
      {children}
    </Animated.View>);
};
const styles = StyleSheet.create({
    container: {
        overflow: "hidden",
    },
});
//# sourceMappingURL=CollapsibleView.js.map